<template>
  <tbody>
    <tr
      class="row"
      :class="{ opened }"
      @click="opened = !opened"
    >
      <td>{{ segmentId }}</td>
      <td>
        <div
          v-if="supOrderRef"
          class="sup-order-ref"
        >
          {{ supOrderRef }}
        </div>
      </td>
      <td>{{ supOrderId }}</td>
      <td class="image">
        <img :src="sparkline">
      </td>
      <td>{{ creationDateProperty }}</td>
      <td>{{ cxlStart }}</td>
      <td>
        <div
          class="status"
          :class="getStatusClassName(status)"
        >
          {{ status }}
        </div>
      </td>
      <td>
        <div class="price">
          {{ totalAmount + ' ' + currency }}
        </div>
      </td>
    </tr>
    <tr
      class="expandable"
      :class="{ opened }"
    >
      <td colspan="8">
        <div class="order-data">
          <div class="photo">
            <img
              :src="imageUrl"
              :alt="hotelName"
            >
          </div>
          <div class="order-info">
            <div class="number">
              <span class="label">Order:</span> <span class="link-view">{{ orderNum }}</span>
            </div>
            <div class="section-1">
              <div class="col-left">
                <div class="address-line-1">
                  {{ hotelDestination }} from {{ checkInDate }} to {{ checkOutDate }}
                </div>
                <div class="address-line-2">
                  <location :house-icon="true">
                    {{ hotelName }}
                  </location>
                  <location :light="true">
                    {{ hotelAddress }}
                  </location>
                  <stars
                    v-if="starRating"
                    :stars="starRating"
                    :show-empty="true"
                  />
                </div>
              </div>
              <div class="col-right options-holder">
                <div
                  v-if="smartbook && smartbook !== '0'"
                  class="options-item"
                >
                  <div class="badge smartbook">
                    Smartbook
                  </div>
                  <div class="price">
                    {{ smartbook + ' ' + sbRbCurrency }}
                  </div>
                </div>
                <div
                  v-if="rebooker && rebooker !== '0'"
                  class="options-item"
                >
                  <div class="badge rebooker">
                    Rebooker
                  </div>
                  <div class="price">
                    {{ rebooker + ' ' + sbRbCurrency }}
                  </div>
                </div>
              </div>
            </div>
            <div class="section-2">
              <table>
                <tr>
                  <td class="label">
                    Order ID
                  </td>
                  <td class="value">
                    {{ supOrderId }}
                  </td>
                  <td class="label">
                    Amount
                  </td>
                  <td class="value">
                    {{ totalAmount + ' ' + currency }}
                  </td>
                  <td class="label">
                    Payment
                  </td>
                  <td class="value">
                    <span class="link-view">{{ payment }}</span>
                  </td>
                </tr>
                <tr>
                  <td class="label">
                    Segment ID
                  </td>
                  <td class="value">
                    {{ segmentId }}
                  </td>
                  <td class="label">
                    Supplier
                  </td>
                  <td class="value">
                    {{ supplier }}
                  </td>
                  <td class="label">
                    Cancellation Policy
                  </td>
                  <td class="value">
                    <span class="link-view">{{ cancelationPolicy }}</span>
                  </td>
                </tr>
                <tr>
                  <td class="label">
                    Creation Date
                  </td>
                  <td class="value">
                    {{ creationDateProperty }}
                  </td>
                  <td />
                  <td />
                  <td />
                  <td />
                </tr>
              </table>
            </div>
          </div>
          <div
            class="order-status"
            :class="getStatusClassName(status)"
          >
            Status: <span>{{ status }}</span>
          </div>
        </div>
      </td>
    </tr>
  </tbody>
</template>

<script>
import Location from './tiny/Location';
import Stars from './tiny/Stars';

export default {
  name: 'rw-orders-table-row',
  components: {
    Location,
    Stars,
  },
  props: {
    segmentId: {
      type: [String, Number],
      default: '',
    },
    supOrderRef: {
      type: [String, Number],
      default: '',
    },
    supOrderId: {
      type: [String, Number],
      default: '',
    },
    creationDateProperty: {
      type: String,
      default: '',
    },
    cxlStart: {
      type: String,
      default: '',
    },
    status: {
      type: String,
      default: '',
    },
    totalAmount: {
      type: [String, Number],
      default: '',
    },
    currency: {
      type: String,
      default: '',
    },
    sbRbCurrency: {
      type: String,
      default: '',
    },
    hotelImg: {
      type: String,
      default: '',
    },
    hotelName: {
      type: String,
      default: '',
    },
    hotelAddress: {
      type: String,
      default: '',
    },
    imageUrl: {
      type: String,
      default: '',
    },
    orderNum: {
      type: String,
      default: '',
    },
    starRating: {
      type: Number,
      default: 0,
    },
    hotelDestination: {
      type: String,
      default: '',
    },
    hotelCountryCode: {
      type: String,
      default: '',
    },
    checkInDate: {
      type: String,
      default: '',
    },
    checkOutDate: {
      type: String,
      default: '',
    },
    supplier: {
      type: String,
      default: '',
    },
    payment: {
      type: String,
      default: '',
    },
    cancelationPolicy: {
      type: String,
      default: '',
    },
    smartbook: {
      type: String,
      default: '',
    },
    rebooker: {
      type: [String, Number],
      default: '',
    },
  },
  data() {
    return {
      opened: false,
    };
  },
  computed: {
    sparkline() {
      if (Math.round(Math.random())) {
        if (Math.round(Math.random())) {
          return require('../assets/sparkline-1.png');
        } else {
          return require('../assets/sparkline-2.png');
        }
      } else {
        if (Math.round(Math.random())) {
          return require('../assets/sparkline-3.png');
        } else {
          return require('../assets/sparkline-4.png');
        }
      }
    },
  },
  methods: {
    getStatusClassName(status) {
      return status.toLowerCase();
    },
  },
};
</script>

<style scoped lang="scss">
.row {
  background-color: #fff;
  border-bottom: 1px solid rgba(#d5dde9, .3);
  cursor: pointer;

  &.opened {
    background-color: #f7f9fc;
  }

  td {
    font-size: 14px;
    font-weight: 500;
    padding: 9px 18px;
    vertical-align: middle;

    &.image {

      img {
        display: block;
        max-width: 135px;
        height: auto;
      }
    }

    .status, .price {
      display: inline-block;
      white-space: nowrap;
      padding: 6px 8px;
      border-radius: 3px;
      font-size: 10px;
      font-weight: 700;
      text-transform: uppercase;
    }

    .status {
      &.ok {
        background-color: rgba(#17cd53, .2);
        color: #3cbf68;
      }
      &.cx {
        background-color: rgba(#ffb400, .2);
        color: #ffb400;
      }
    }

    .price {
      background-color: rgba(#8fb6f5, .2);
      color: #8fb6f5;
    }
  }
}

.expandable {
  display: none;
  background-color: #f7f9fc;
  border-bottom: 1px solid rgba(#d5dde9, .3);

  &.opened {
    display: table-row;
  }

  > td {
    padding: 18px;
  }
}

.order {

  &-data {
    display: flex;
    align-items: flex-start;

    .photo {
      width: 200px;
      height: 190px;
      position: relative;
      margin-right: 16px;

      img {
        display: block;
        background: #faebd7;
        text-align: center;
        line-height: 30px;
        font-weight: bold;
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        object-fit: cover;
      }
    }
  }

  &-info {
    flex-grow: 1;
    margin-right: 16px;
    font-size: 13px;

    .number {
      font-weight: 700;
      line-height: 20px;
      margin-bottom: 12px;

      .label {
        color: #32325a;
      }
    }

    .section-1 {
      display: flex;
      padding-bottom: 10px;
      border-bottom: 1px solid rgba(#6e7c91, .07);

      .col-left {
        margin-right: 80px;
      }
    }

    .section-2 {
      padding-top: 8px;

      table {
        font-size: 14px;

        td {
          padding: 8px 24px 8px 0;

          &.label {
            font-weight: 500;
          }

          &.value {
            font-weight: 700;
          }
        }
      }
    }
  }

  &-status {
    padding: 12px 10px;
    color: #fff;
    font-size: 15px;
    font-weight: 700;
    border-radius: 3px;
    white-space: nowrap;

    &.ok {
      background-color: #56b282;
    }

    &.cx {
      background-color: #ffb400;
    }

    span {
      text-transform: uppercase;
    }
  }
}

.address-line-1 {
  margin-bottom: 12px;
}

.address-line-2 {
  display: flex;
  align-items: flex-start;

  .location {
    margin-right: 14px;
  }
}

.options {

  &-item {
    display: flex;
    align-items: center;
    margin-bottom: 2px;

    .badge {
      flex-shrink: 0;
      min-width: 80px;
      margin-right: 8px;
      padding: 6px 8px;
      font-size: 13px;
      font-weight: 500;
      border-radius: 3px;

      &.smartbook {
        background-color: rgba(#fb5659, .2);
        color: #ff5252;
      }
      &.rebooker {
        background-color: rgba(#6558fe, .2);
        color: #6972de;
      }
    }

    .price {
      white-space: nowrap;
      font-size: 13px;
      color: #3cbf68;
      font-weight: 700;
      padding-left: 9px;
      background-image: url('../assets/icons/arrow-up-green.png');
      background-repeat: no-repeat;
      background-size: 6px auto;
      background-position: 0 50%;
    }
  }
}
.link-view {
  white-space: nowrap;
  font-weight: 700;
  color: #6972de;
  text-decoration: underline;
}
</style>
